import React, { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useQueryParam, StringParam } from "use-query-params";

import SearchProducts from "../../Components/Product/Search";
import {
  DialogTitle,
  Dialog,
  DialogContent,
  IconButton,
  Box,
  Typography,
} from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";

function SearchProductDialog() {
  const location = useLocation();
  const history = useHistory();

  const [openDialog] = useQueryParam("openDialog", StringParam);
  const [search] = useQueryParam("search", StringParam);

  // const [{ openDialog, search }] = useQueryString(location);

  const open = openDialog === "search-product";

  return (
    <Dialog fullScreen open={open}>
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h4"> Pesquisar produtos </Typography>
          <IconButton onClick={() => history.goBack()}>
            <ClearIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <SearchProducts initialSearch={search} />
      </DialogContent>
    </Dialog>
  );
}

export default SearchProductDialog;
